import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { StoreInitializationService } from '../services/store-initialization.service';

export const dashboardInitializationGuard: CanActivateFn = () =>
  inject(StoreInitializationService)
    .ensureInitialized()
    .pipe(map(() => true));
